const triggerClick = (element) => {
    if (!element) {
        return;
    }

    if (typeof element.click === 'function') {
        element.click();
        return;
    }

    let clickEvent;

    if (typeof MouseEvent === 'function') {
        clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
    } else if (typeof document !== 'undefined' && typeof document.createEvent === 'function') {
        clickEvent = document.createEvent('MouseEvents');
        clickEvent.initMouseEvent(
            'click',
            true,
            true,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
        );
    }

    if (clickEvent) {
        element.dispatchEvent(clickEvent);
    }
};

const closeDropdowns = () => {
    if (typeof document === 'undefined') {
        return false;
    }

    const dropdownToggles = document.querySelectorAll('.dropdown.open .dropdown-toggle');

    if (!dropdownToggles.length) {
        return false;
    }

    dropdownToggles.forEach((toggle) => {
        triggerClick(toggle);
    });

    return true;
};

const closeReactWidgets = () => {
    if (typeof document === 'undefined') {
        return false;
    }

    let closedSomething = closeDropdowns();

    const openWidgets = document.querySelectorAll('.rw-open, .rw-popup-container');

    if (!openWidgets.length) {
        return closedSomething;
    }

    if (typeof document.activeElement?.blur === 'function') {
        document.activeElement.blur();
    }

    const escapeEvent = new KeyboardEvent('keydown', {
        key: 'Escape',
        keyCode: 27,
        which: 27,
        bubbles: true
    });

    document.dispatchEvent(escapeEvent);

    // react-widgets closes popups async so give browser a tick
    const cleanup = () => {
        openWidgets.forEach((widget) => {
            widget.classList.remove('rw-open');
        });
    };

    if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(cleanup);
    } else {
        setTimeout(cleanup, 0);
    }

    return true;
};

export default closeReactWidgets;
